module.exports = ".page-footer-img {\n  background-color: #f8f8f8; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/components/footer.component.scss
// module id = ./src/app/footer/components/footer.component.scss
// module chunks = main